{
    "title": "Company Information",
    "input":{
        "registeredName": "Registered Name",
        "tradingName": "Trading Name",
        "registeredNumber": "Tax Identification Number (TIN)",
        "corporateTaxReferenceNumber": "Corporate Tax Reference Number",
        "corporateStructure": "Corporate Structure",
        "websiteAddress": "Website Address",
        "emailAddress": "E-mail Address",
        "telephoneNumber": "Telephone Number",
        "establishedOn": "Established On"
    }
}